<template>
  <div class="cling-overlay" :style="{width: size.w+'px', height: size.h+'px', background : 'url(' + poster + ') no-repeat center center', backgroundSize: 'cover'}">
    <tag :videoId="videoId" :duration="duration" :dimensions="size" :key="tag.id" :tag="tag" :current-frame="currentFrame" v-on:activate="update(true)"
      v-on:deactivate="update()" v-on:videoaction="onVideoAction" v-on:open="onOpen" v-on:action="onAction" v-for="tag in tagsToDisplay"></tag>
  </div>
</template>

<script>
  import tag from './tag'

  var vendors = ['webkit', 'moz']
  for (var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
    window.requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame']
    window.cancelAnimationFrame = window[vendors[x] + 'CancelAnimationFrame'] || window[vendors[x] + 'CancelRequestAnimationFrame']
  }

  export default {
    name: 'cling-overlay',
    props: {
      videoId: {
        type: String,
        default: function () {
          return null
        }
      },
      poster: {
        type: String,
        default: ''
      },
      tags: {
        type: Array,
        default: function () {
          return []
        }
      },
      onActivate: String,
      originalVideoDimension: {
        type: Object,
        required: true
      }
    },
    created() {
      this.$nextTick(() => {
        const el = document.getElementById(this.videoId)
        if (this.videoId && el) {
          this.videoElement = el
          this.setListener()
          this.resize()
        } else {
          console.error('Cling:Viewer: VideoTag not found')
        }
      })
    },
    data: function () {
      return {
        videoElement: null,
        currentTime: null,
        duration: null,
        frames: [],
        dots: [],
        currentIntervall: null,
        currentFrame: 0,
        skipFrames: 0,
        size: { h: 0, w: 0, scaleFactorW: 1, scaleFactorH: 1 }
      }
    },

    computed: {
      tagsToDisplay: function () {
        return this.tags.filter(tag => tag.template !== 'markerTag').reverse()
      }
    },

    methods: {
      update(active) {
        if (active) {
          if (this.onActivate === 'pause') {
            this.videoElement.pause()
          } else if (!isNaN(parseFloat(this.onActivate))) {
            this.videoElement.playbackRate = parseFloat(this.onActivate)
          }
        } else {
          if (this.onActivate === 'pause') {
            this.videoElement.play()
          } else if (!isNaN(parseFloat(this.onActivate, 10))) {
            this.videoElement.playbackRate = 1
          }
        }
      },
      onVideoAction(action) {
        console.log('on Video action', action)
        if (action.action === 'pause') {
          this.videoElement.pause()
        } else if (action.action === 'play') {
          this.videoElement.play()
        } else if (action.action === 'jumpTo') {
          this.videoElement.currentTime = action.value
          if (action.modifier === 'pause') {
            this.videoElement.pause()
          } else if (action.modifier === 'play') {
            this.videoElement.play()
          }
        } else if (action.action === 'sleep') {
          const ms = parseInt(action.value)
          if (typeof ms === 'number') {
            this.videoElement.pause()
            setTimeout(() => {
              this.videoElement.play()
            }, ms)
          }
        } else if (action.action === 'open') {
          this.$emit('open', {
            'target': '_self',
            'value': action.value
          })
        }
      },
      setListener() {
        /*
        this.videoElement.addEventListener('timeupdate', (e) => {
            this.currentTime = Math.round(e.target.currentTime * 10)
        })
        */
        this.videoElement.addEventListener('canplay', (e) => {
          this.resize()
        })
        this.videoElement.addEventListener('durationchange', (e) => {
          // this.resize()
          this.duration = Math.round(e.target.duration * 20)
        })
        this.videoElement.addEventListener('playing', () => {
          this.start()
        })
        // this.videoElement.addEventListener('ended', () => {
        //    this.stop()
        // })
        this.videoElement.addEventListener('pause', () => {
          this.stop()
        })
        window.addEventListener('resize', this.resize)
      },
      resize() {
        try {
          var cR = this.videoElement.getBoundingClientRect()
          this.size.w = cR.width
          this.size.h = cR.height
          this.size.scaleFactorW = (cR.width / this.originalVideoDimension.width) || 1
          this.size.scaleFactorH = (cR.height / this.originalVideoDimension.height) || 1
        } catch (e) {
          console.error('Error while getting size of element', e)
        }
      },
      start() {
        /*
        if (this.currentIntervall) {
          this.stop()
        }
        */
        // this.currentIntervall = this.play()
        this.play()
      },
      stop() {
        this.stopped = true
        // clearInterval(this.currentIntervall)
      },
      loop(raft) {
        if (this.stopped) {
          return
        }
        window.requestAnimationFrame(this.loop)

        let now = Date.now()
        let elapsed = now - this.then

        if (elapsed > this.fpsInterval) {
          this.then = now - (elapsed % this.fpsInterval)
          var t = Math.round(this.videoElement.currentTime * 20) // 20 synced to number of frames we got in the interpolation, see utils interpolate
          // console.log('set currentFrame', t)
          this.currentFrame = t
        } else {
          // console.log('skip frame')
        }
      },
      play() {
        this.fps = 10
        this.fpsInterval = 1000 / this.fps
        this.then = Date.now()
        this.startTime = this.then
        this.stopped = false
        this.loop(this.startTime)
        /*
          return setInterval(() => {
              var t = Math.round(this.videoElement.currentTime * 10)
              console.log('set currentFrame', t, this.currentIntervall)
              this.currentFrame = t
          }, 100)
          */
      },
      onOpen(val) {
        // re-emmit to bubble
        console.log('overlay onOpen handler', val)
        this.$emit('open', val)
      },
       onAction(val) {
        // re-emmit to bubble
        console.log('overlay onAction handler', val)
        this.$emit('action', val)
      }
    },
    components: { tag }
  }

</script>

<style lang="scss" scoped>
  .cling-overlay {
    position: absolute;
    top: 0;
    left: 0;
    pointer-events: none;
    overflow: hidden;
    z-index: 1000;
  }

  svg.line {
    transition: all 100ms linear;
    width: 100%;
    height: 100%;
  }

  dot {
    z-index: 8888;
  }

  tag {
    z-index: 9999;
  }
</style>
